export function sendOK() {
  // This can be used for external testing as a signal that everything is... 'OK'.
  if (window?.parent?.postMessage) {
    // using '*' as target origin isn't great practise, but the message will only ever be 'OK'
    window.parent.postMessage('OK', '*');
  }
}
